<script setup lang="ts">
  import { useAttrs } from "vue";

  type CardMode = "primary" | "secondary";

  interface Props {
    mode?: CardMode;
  }

  const props = withDefaults(defineProps<Props>(), {
    mode: "primary",
  });

  const emit = defineEmits<{ click: [event: PointerEvent] }>();

  function handleClick(event: PointerEvent) {
    emit("click", event);
  }

  const attrs = useAttrs();
</script>

<template>
  <div :class="[$style.card, $style[`card--${props.mode}`], attrs.class]" @click="handleClick">
    <slot />
  </div>
</template>

<style lang="scss" module>
  .card {
    border-radius: calc(0.625rem * 0.8); //var(--radius)
    border: 1px solid var(--border);

    padding: 16px;

    transition:
      background-color 0.2s ease,
      border-color 0.2s ease;

    &--primary {
      background: inherit;
      border-color: var(--border);
    }

    &--secondary {
      background: var(--card);
    }
  }
</style>
